import LegalDoc from "./LegalDoc";

export default function CondizioniAcquisto() {
  return (
    <LegalDoc
      field="legal_purchase"
      overline="Termini e condizioni"
      title={<>Condizioni di <span className="italic text-[#D47738]">acquisto</span></>}
      related={[
        { to: "/condizioni-consegna", label: "Condizioni di consegna" },
        { to: "/politica-rimborso", label: "Politica di rimborso" },
        { to: "/condizioni-legali", label: "Condizioni legali" },
      ]}
    />
  );
}
